(function(ws) {
    'use strict';

    ws.views.recentItems = ws.views.baseWidget.extend({
        GTM_EVENT_CATEGORY: 'store_dashboard',

        events: {
            'click table a': 'trackTableLink',
            'click .cta-link a': 'trackCtaLink'
        },

        /**
         * Initializes the component.
         */
        initialize() {
            ws.views.baseWidget.prototype.initialize.call(this);
        },

        /**
         * Sends data from a link in the table to Google Analytics;
         * this.GTM_EVENT_LABEL must be defined in an extended class.
         *
         * @param {Event} e
         */
        trackTableLink: function(e) {
            // Stop the link from navigating away
            e.preventDefault();

            // Send tracking data to Google Analytics
            this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION, this.GTM_EVENT_LABEL);

            this.adobeDashboardTracking(e);
        },

        /**
         * Sends data from a Cta_link to Google Analytics;
         * this.GTM_EVENT_LABEL must be defined in an extended class.
         *
         * @param {Event} e
         */
        trackCtaLink: function(e) {
            // Stop the link from navigating away
            e.preventDefault();
            this.GTM_EVENT_LABEL = 'cta_button';

            // Send tracking data to Google Analytics
            this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION, this.GTM_EVENT_LABEL);

            this.adobeDashboardTracking(e);
        },

        adobeDashboardTracking: function (e) {
            // Send tracking data to adobe Analytics
            dataLayerAA.event = {};
            dataLayerAA.event.action = this.ADOBE_EVENT_ACTION;
            dataLayerAA.event.label = e.target.text.toLowerCase();
            _satellite.track('event:dashboard');

            // Navigate away after the tracking is complete
            window.location.href = $(e.currentTarget).attr('href');
        }
    });
})(westcon);
